<template>
  <div v-if="!cookieAccepted" class="cookies">
    <picture class="cookies__picture">
      <img
        class="cookies__img"
        src="@/assets/logo-simple.svg"
        alt="Robot"
        width="100"
        height="100"
      />
    </picture>

    <div class="cookies__text">
      <p class="cookies__main">
        {{ $t('component_the_cookies_description') }}
      </p>

      <p class="cookies__sub" v-html="$t('component_the_cookies_details')" />
    </div>

    <button
      class="cookies__btn btn btn--green"
      type="button"
      data-test="cookies-allow-btn"
      @click="allowCookies"
    >
      {{ $t('form_button_allow') }}
    </button>
  </div>
</template>

<script>
export default {
  name: 'LayoutCookies',

  data() {
    return {
      cookieAccepted: !!localStorage.getItem('cookiesAccepted'),
    };
  },

  methods: {
    allowCookies() {
      localStorage.setItem('cookiesAccepted', true);

      this.cookieAccepted = true;

      this.$amplitude.logEvent('Cookies_usage_approved');
    },
  },
};
</script>

<style lang="scss" scoped>
.cookies {
  $this: 'cookies';
  position: fixed;
  left: 50%;
  transform: translate(-50%);
  display: grid;
  align-items: center;
  background: rgba(20, 20, 43, 0.75);
  border-radius: 16px;
  z-index: 999;
  grid-template-columns: 1fr;
  width: 92%;
  bottom: 16px;
  padding: 16px;

  @include media('md') {
    grid-template-columns: 80px 1fr 115px;
    column-gap: 24px;
    width: 640px;
    bottom: 30px;
    padding: 16px 24px;
  }

  @include media('xl') {
    grid-template-columns: 100px 1fr 115px;
    column-gap: 32px;
    width: 940px;
    padding: 24px 32px;
  }

  &__picture {
    display: none;

    @include media('md') {
      display: block;
    }
  }

  &__img {
    width: 60px;
    height: 60px;

    @include media('md') {
      width: 80px;
      height: 80px;
    }

    @include media('xl') {
      width: 100px;
      height: 100px;
    }
  }

  &__main {
    font-weight: 600;
    margin-bottom: 8px;
    letter-spacing: 0.75px;
    color: $white;
    font-size: 16px;
    line-height: 24px;

    @include media('xl') {
      font-size: 21px;
      line-height: 29px;
    }
  }

  &__sub {
    letter-spacing: 0.75px;
    color: $white;
    font-size: 12px;
    line-height: 18px;
    margin-bottom: 15px;

    @include media('md') {
      margin-bottom: 0;
    }

    @include media('xl') {
      font-size: 17px;
      line-height: 34px;
    }
  }

  &__link {
    text-decoration: underline;
    color: $white;
  }

  &__btn {
    height: 64px;
    border-radius: 16px;
  }
}
</style>
